import { lazy } from 'react';

// project imports
import Loadable from '../ui-component/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

// login option 3 routing
const AuthLogin = Loadable(lazy(() => import('../views/pages/authentication/authentication/Login')));
const LocalLogin = Loadable(lazy(() => import('../views/pages/authentication/authentication/LocalLogin')));
const AuthLoginIDM = Loadable(lazy(() => import('../views/pages/authentication/authentication/IDMLogin')));

const AuthCallback = Loadable(lazy(() => import('../views/pages/authentication/AuthCallback')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <AuthLogin />
    },
    // {
    //   path: '/login-litnet',
    //   element: <LoginLitnet />
    // },
    {
      path: '/local-login',
      element: <LocalLogin />
    },
    // {
    //   path: '/auth/callback',
    //   element: <AuthCallback />
    // },
    {
      path: '/login-idm',
      element: <AuthLoginIDM />
    },
    // {
    //   path: '/pages/login/login3',
    //   element: <AuthLogin3 />
    // },
    // {
    //   path: '/pages/register/register3',
    //   element: <AuthRegister3 />
    // }
  ]
};

export default AuthenticationRoutes;
